import { Action } from '@ngrx/store';

import { DecodeVinResponse, PostalResponse, ProductFormResponse } from '@app-model/api';
import { LoadQuote } from '@app-model/cart';

import { VehicleValues } from './vehicle.reducer';

/**
 * vehicle store.
 * UI will call API and
 * get all form data to create formgroup.
 */
export const GET_PRODUCT_FORM = '[VEHICLE] GET PRODUCT FORM';
export const GET_PRODUCT_FORM_SUCCESS = '[VEHICLE] GET PRODUCT FORM SUCCESS';
export const RESET_PRODUCT_FORM = '[VEHICLE] RESET PRODUCT';
export const DECODE_VIN = '[VEHICLE] DECODE VIN';
export const DECODE_VIN_SUCCESS = '[VEHICLE] DECODE VIN SUCCESS';
export const DECODE_VIN_FAILURE = '[VEHICLE] DECODE VIN FAILURE';
export const GET_MAKE = '[VEHICLE] GET MAKE';
export const GET_MODEL = '[VEHICLE] GET MODEL';
export const GET_TRIM = '[VEHICLE] GET TRIM';
export const SHOW_INSERVICE_DATE_AND_ODO = '[VEHICLE] SHOW INSERVICE DATE AND ODOMETER';
export const DECODE_VIN_MANUAL = '[VEHICLE] DECODE VIN MANUAL';
export const UPDATE_PRODUCT_FORM = '[VEHICLE] UPDATE PRODUCT FORM';
export const LOAD_VEHICLE_QUOTE = '[VEHICLE] LOAD VEHICLE QUOTE';
export const VEHICLE_FAILURE = '[VEHICLE] VEHICLE FAILURE';
export const GET_CUSTOMER_POSTAL = '[PRODUCT] GET CUSTOMER POSTAL';
export const CLEAR_CUSTOMER_POSTAL = '[PRODUCT] CLEAR CUSTOMER POSTAL';
export const GET_CUSTOMER_POSTAL_SUCCESS = '[PRODUCT] GET CUSTOMER POSTAL SUCCESS';

export class GetProductFormAction implements Action {
  readonly type = GET_PRODUCT_FORM;
}

export class GetProductFormSuccessAction implements Action {
  readonly type = GET_PRODUCT_FORM_SUCCESS;

  constructor(public payload: ProductFormResponse) {}
}

export class UpdateProductFormAction implements Action {
  readonly type = UPDATE_PRODUCT_FORM;

  constructor(public payload: VehicleValues) {}
}

export class DecodeVinAction implements Action {
  readonly type = DECODE_VIN;

  constructor(public payload: string) {}
}

export class DecodeVinSuccessAction implements Action {
  readonly type = DECODE_VIN_SUCCESS;

  constructor(public payload: DecodeVinResponse) {}
}

export class DecodeVinFailureAction implements Action {
  readonly type = DECODE_VIN_FAILURE;

  constructor(public payload: DecodeVinResponse) {}
}

export class DecodeVinManualAction implements Action {
  readonly type = DECODE_VIN_MANUAL;

  constructor(public payload: DecodeVinResponse) {}
}

export class GetMakeAction implements Action {
  readonly type = GET_MAKE;

  constructor(public payload: { year: string }) {}
}

export class GetModelAction implements Action {
  readonly type = GET_MODEL;

  constructor(public payload: { year: string; make: string }) {}
}

export class GetTrimAction implements Action {
  readonly type = GET_TRIM;

  constructor(public payload: { year: string; make: string; model: string }) {}
}

export class ShowInsDateAndOdometerAction implements Action {
  readonly type = SHOW_INSERVICE_DATE_AND_ODO;
}

export class LoadVehicleQuoteAction implements Action {
  readonly type = LOAD_VEHICLE_QUOTE;

  constructor(public payload: LoadQuote) {}
}

export class VehicleFailureAction implements Action {
  readonly type = VEHICLE_FAILURE;

  constructor(public payload: any) {}
}

export class ResetProductFormAction implements Action {
  readonly type = RESET_PRODUCT_FORM;
}

export class GetCustomerPostalAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL;

  constructor(public payload: { zipCode: string; values: any }) {}
}

export class GetCustomerPostalSuccessAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {}
}

export class ClearCustomerPostalAction implements Action {
  readonly type = CLEAR_CUSTOMER_POSTAL;
}

export type All =
  | GetProductFormAction
  | GetProductFormSuccessAction
  | DecodeVinAction
  | DecodeVinSuccessAction
  | DecodeVinFailureAction
  | VehicleFailureAction
  | DecodeVinManualAction
  | GetMakeAction
  | GetModelAction
  | GetTrimAction
  | ShowInsDateAndOdometerAction
  | UpdateProductFormAction
  | ResetProductFormAction
  | LoadVehicleQuoteAction
  | GetCustomerPostalAction
  | GetCustomerPostalSuccessAction
  | ClearCustomerPostalAction;
